import api from 'api';
import { fipeClient, parallelumClient, getParallelumVehicleTypePath, toFipeVehicleType } from './parallelumClient';

let _cachedReferenceCode = null;
let _cachedReferenceExpiry = 0;

async function getReferenceTableCode() {
  const now = Date.now();
  if (_cachedReferenceCode && now < _cachedReferenceExpiry) return _cachedReferenceCode;
  const resp = await fipeClient.post('/ConsultarTabelaDeReferencia');
  _cachedReferenceCode = resp.data[0].Codigo;
  _cachedReferenceExpiry = now + 24 * 60 * 60 * 1000;
  return _cachedReferenceCode;
}

function mapBrandsFromFipe(data) {
  return (data || []).map((item) => ({ Value: item.Value, Label: item.Label }));
}

function mapBrandsFromParallelum(data) {
  return (data || []).map((item) => ({ Value: item.code, Label: item.name }));
}

function mapModelsFromFipe(data) {
  const models = data?.Modelos || data || [];
  return models.map((item) => ({ Value: item.Value, Label: item.Label }));
}

function mapModelsFromParallelum(data) {
  return (data || []).map((item) => ({ Value: item.code, Label: item.name }));
}

function mapYearsFromFipe(data) {
  return (data || []).map((item) => ({ Value: item.Value, Label: item.Label }));
}

function mapYearsFromParallelum(data) {
  return (data || []).map((item) => ({ Value: item.code, Label: item.name }));
}

export async function listBrands({ type }) {
  const fipeType = toFipeVehicleType(type);
  try {
    const codTabela = await getReferenceTableCode();
    const resp = await fipeClient.post('/ConsultarMarcas', {
      codigoTabelaReferencia: codTabela,
      codigoTipoVeiculo: fipeType,
    });
    return mapBrandsFromFipe(resp.data);
  } catch (err) {
    const path = getParallelumVehicleTypePath(fipeType);
    const resp = await parallelumClient.get(`/${path}/brands`);
    return mapBrandsFromParallelum(resp.data);
  }
}

export async function listModels({ brand, type }) {
  const fipeType = toFipeVehicleType(type);
  try {
    const codTabela = await getReferenceTableCode();
    const resp = await fipeClient.post('/ConsultarModelos', {
      codigoTabelaReferencia: codTabela,
      codigoTipoVeiculo: fipeType,
      codigoMarca: brand,
    });
    return mapModelsFromFipe(resp.data);
  } catch (err) {
    const path = getParallelumVehicleTypePath(fipeType);
    const resp = await parallelumClient.get(`/${path}/brands/${brand}/models`);
    return mapModelsFromParallelum(resp.data);
  }
}

export async function listYearModels({ brand, model, type }) {
  const fipeType = toFipeVehicleType(type);
  try {
    const codTabela = await getReferenceTableCode();
    const resp = await fipeClient.post('/ConsultarAnoModelo', {
      codigoTabelaReferencia: codTabela,
      codigoTipoVeiculo: fipeType,
      codigoMarca: brand,
      codigoModelo: model,
    });
    return mapYearsFromFipe(resp.data);
  } catch (err) {
    const path = getParallelumVehicleTypePath(fipeType);
    const resp = await parallelumClient.get(`/${path}/brands/${brand}/models/${model}/years`);
    return mapYearsFromParallelum(resp.data);
  }
}

export async function getFipe({ fuel, yearModel, model, brand, type }) {
  const fipeType = toFipeVehicleType(type);
  const year = String(yearModel).split('-')[0];
  const code = String(yearModel).split('-')[1];
  let fipeData = null;

  try {
    const codTabela = await getReferenceTableCode();
    const label = { 1: 'carro', 2: 'moto', 3: 'caminhao' };
    const resp = await fipeClient.post('/ConsultarValorComTodosParametros', {
      codigoTabelaReferencia: codTabela,
      codigoMarca: brand,
      codigoModelo: model,
      codigoTipoVeiculo: fipeType,
      anoModelo: year,
      codigoTipoCombustivel: fuel,
      tipoVeiculo: label[fipeType] || 'carro',
      tipoConsulta: 'tradicional',
    });
    fipeData = {
      Marca: resp.data.Marca,
      Modelo: resp.data.Modelo,
      AnoModelo: resp.data.AnoModelo,
      Valor: resp.data.Valor,
      Combustivel: resp.data.Combustivel,
      CodigoFipe: resp.data.CodigoFipe,
    };
  } catch (err) {
    const path = getParallelumVehicleTypePath(fipeType);
    const yearCodeQuery = code ? `${year}-${code}` : `${year}-${fuel}`;
    const resp = await parallelumClient.get(`/${path}/brands/${brand}/models/${model}/years/${yearCodeQuery}`);
    fipeData = {
      Marca: resp.data.brand,
      Modelo: resp.data.model,
      AnoModelo: resp.data.modelYear,
      Valor: resp.data.price,
      Combustivel: resp.data.fuel,
      CodigoFipe: resp.data.codeFipe,
    };
  }

  const response = await api({
    method: 'POST',
    url: '/getFipe',
    data: { fipeData, brand, model, type, fuel },
    headers: {
      apiKey: 'a3607db1-530f-4565-93a1-7c2ff693c8db',
      apiSecret: 'f2b85508-8097-4adf-990a-6ba37b246fc1',
    },
  });
  return response?.data;
}
